/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useMemo, Fragment } from "react";

// antd:
// import { LoadingOutlined } from "@ant-design/icons";
import { Space } from "antd";

// eslint-disable-next-line node/no-missing-import
import type * as CSS from "csstype";

// My Components:
// import DivE from "../react/DivE.tsx";
// Redux-hooks:
import { useAppSelector } from "../../libs/redux-hooks.ts"; // useAppDispatch
// Reducers:
import { getElementState, getLng, getUser } from "../../libs/reducer.ts";
// My functions
import fnc from "../../libs/fnc.ts";
// Types:
import type {TuniversalElementProps} from "../../types/Iuigen.d.ts";
import type {Tpermissions} from "../../types/easyTypes.ts";

type Tspace = {
  direction:"horizontal" | "vertical",
  align?:"start" | "end" | "center" | "baseline",
  size?:"small" | "middle" | "large",
  wrap:boolean,
  compact:boolean
};

const { rz } = window;

const RZspace:FC<TuniversalElementProps> = ({attributes, children}) => {
  RZspace.displayName = "Space";
  const user = useAppSelector(getUser);
  const lng = useAppSelector(getLng);
  const rlng = (lng === "en" ? "ru" : "en");

  const {rootAttributes, key, fullPath, type} = attributes; // onClick, onChange, onRightClick, onHover, onLoad
  const elState = useAppSelector(getElementState(rootAttributes.key, fullPath)); // value, visible, disabled, loading, userStyle, userClass
  // const rootNamespace = useMemo(() => (window[rootAttributes?.key || rz.strMakeID(24)]), [rootAttributes?.key]);

  const permissions = useMemo<Tpermissions>(() => (fnc.checkPermissions(user, attributes)), [user, attributes]);

  const spaceType = useMemo<Tspace>(() => {
    const typ:Tspace = {size: "small", direction: "horizontal", wrap: false, compact: false};
    (type || "").toLowerCase().replace((/(\s+|_|\|)/igm), " ").split(" ").forEach((tt) => {
      if (~["small", "middle", "large"].indexOf(tt)) { typ.size = tt }
      else if (~["start", "end", "center", "baseline"].indexOf(tt)) { typ.align = tt }
      else if (~["vertical", "horizontal"].indexOf(tt)) { typ.direction = tt }
      else if (tt === "wrap") { typ.wrap = true }
      else if (tt === "compact") { typ.compact = true }

      if (attributes?.size) { typ.size = attributes.size }
      if (attributes?.compact === "true") { typ.compact = true } else if (attributes?.compact === "false") { typ.compact = false }
      if (attributes?.wrap === "true") { typ.wrap = true } else if (attributes?.wrap === "false") { typ.wrap = false }
      if (attributes?.align) { typ.align = attributes.align }
      if (attributes?.direction) { typ.direction = attributes.direction }
    });
    return typ;
  }, [type, attributes]);

  const clsu = useMemo<Array<string>>(() => {
    const userClss = rz.objClone(elState?.userClass || []);
    if ((elState?.disabled || permissions.disabled === true) && !~userClss.indexOf("uk-disabled")) { userClss.push("uk-disabled") }
    return userClss;
  }, [elState?.userClass, elState?.disabled, permissions]);

  const styl = useMemo<CSS.Properties>(() => {
    const est = {...elState.userStyle};
    if ((elState?.visible === false || permissions.visible === false) && est.display !== "none") { est.display = "none" }
    else if ((elState?.visible === true && permissions.visible !== false) && est.display === "none") { est.display = undefined }
    return est;
  }, [elState?.userStyle, elState?.visible, permissions]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const tooltip = useMemo<string | undefined>(() => (elState.attributes["tooltip_" + lng] || elState.attributes.tooltip || elState.attributes["tooltip_" + rlng]), [elState.attributes, lng]);

  if (spaceType.compact) {
    return (
      <Space.Compact
        key={key} className={clsu.join(" ")} style={styl}
        block
        size={spaceType.size}
        direction={spaceType.direction}
        uk-tooltip={tooltip}
        aria-disabled={elState.disabled}
      >
        {children}
        {/* <Input style={{ width: 'calc(100% - 200px)' }} defaultValue="Shpalich-soft" /> */}
      </Space.Compact>
    );
  }

  return (
    <Space
      key={key} id={key} className={clsu.join(" ")} style={styl}
      size={spaceType.size}
      direction={spaceType.direction}
      align={spaceType.align}
      wrap={spaceType.wrap}
      uk-tooltip={tooltip}
      aria-disabled={elState.disabled}
    >
      {children}
    </Space>
  );
}

export default RZspace;
/* eslint-enable @typescript-eslint/no-unused-vars */
